<script lang="ts">
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import IconComponent from "@/components/atoms/Icon.vue";
import { IconName, PerformanceQASelectors } from "webshop-modules";

@Component({
    components: {IconComponent}
})
export default class TextInputComponent extends Vue {

    @Prop()
    public label: string | undefined;

    @Prop()
    public name!: string;

    @Prop()
    public value: string | undefined;

    @Prop()
    public hasSubmitAction: boolean = true;

    @Prop()
    public inputQaSelector: string | undefined;

    @Prop()
    public actionQaSelector: string | undefined;

    @Emit()
    public input(event: Event): string {
        const target: HTMLInputElement = <HTMLInputElement>event.target;

        this.placeholderState = target.value === '';

        return target.value;
    }

    @Emit()
    public submit(event: Event): Event {
        return event;
    }

    public readonly iconName: typeof IconName = IconName;

    public placeholderState: boolean = true;

    private async created() {
        this.placeholderState = this.value === undefined || this.value.length === 0;
    }

}
</script>

<template>
    <div class="a-formField">
        <transition name="fade">
            <label class="a-formField__placeholder" v-if="label && placeholderState" :for="name">{{ label }}</label>
        </transition>

        <div v-if="hasSubmitAction" class="a-formField__action" v-on:click="submit" :data-qa="actionQaSelector">
            <IconComponent :icon-id="iconName.ArrowFull"/>
        </div>

        <input class="a-formInput"
               type="text"
               v-on:input="input"
               v-on:click="placeholderState = false"
               v-on:blur="placeholderState = value === ''"
               v-on:keyup.enter="submit"
               :id="name"
               :name="name"
               :value="value"
               :data-qa="inputQaSelector"
        />
    </div>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
    opacity: 0;
}
</style>
